import React, { ChangeEventHandler, FocusEventHandler } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    data?: any[];
    label: string;
    name: string;
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: string | undefined;
    defineValue?: string | undefined;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    disabled?: boolean;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    optionValue?: string | undefined;
};

const FieldSelect = ({
    data,
    label,
    name,
    size,
    margin,
    required,
    touched,
    errors,
    value,
    defineValue,
    disabled,
    onChange,
    onBlur,
    optionValue,
}: Props) => {
    //onChange Formik
    //The variable filedSelectFormik must be equal to the variable name of the formik
    //onChange={formik.handleChange}

    return (
        <TextField
            id="select-field"
            select
            fullWidth
            label={label}
            name={name}
            value={value}
            required={required}
            margin={margin}
            disabled={disabled}
            onBlur={onBlur}
            onChange={onChange}
            size={size}
            helperText={touched ? errors : ''}
            error={touched && Boolean(errors)}
        >
            {/*<MenuItem key="" value="">VACIO</MenuItem>*/}
            {data &&
                data?.map((option: any) => (
                    <MenuItem
                        key={option.id}
                        value={defineValue === 'name' ? option.name : option.id}
                    >
                        {!optionValue ? option.name : option[optionValue]}
                    </MenuItem>
                ))}
        </TextField>
    );
};

export default FieldSelect;
